import React from "react";

import { About, Footer, Header, Testimonial, Work } from "./containers";
import { Navbar, ProgressiveBar } from "./components";
import "./App.scss";

const App = () => {
  return (
    <div className="app">
      <ProgressiveBar />
      <Navbar />
      <Header />
      <About />
      <Work />
      {/* <Skills /> */}
      <Testimonial />
      <Footer />
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17411.7603331779!2d72.95078500444917!3d19.211410288845016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9d01094b4d5%3A0x4a1c8b704ec28a7a!2sSign%20Board%20Painter%2C%20hand%20painting%20-%20Ravindranath%20Arts!5e0!3m2!1sen!2sin!4v1648051942859!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        title="map"
      ></iframe>
      <div className="main_footer">
        <p>@2022 RAVINDRANATH KUSHWAHA | All rights reserved</p>
        <p>
          Made with{" "}
          <span role="img" aria-label="love">
            ❤️
          </span>{" "}
          for my dad by{" "}
          <a
            href="http://abhijeetkwh.vercel.app/"
            target="_blank"
            rel="noreferrer"
          >
            Abhijeet Kushwaha
          </a>
        </p>
      </div>
    </div>
  );
};

export default App;
